import styled, { css } from 'styled-components'
import logo from 'src/assets/imgs/logo/main_logo.png'
import { COLOR } from 'src/constants/colors'

export const PageLayoutWrap = styled.div<{ media?: string }>`
  display: flex;
  min-height: ${(props) => (props.media === 'pc' ? '945px' : 'unset')};
  height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;

  input[type='password']::-ms-reveal,
  input[type='password']::-ms-clear {
    display: none;
  }
`

export const LeftLayoutWrap = styled.div<{ media?: string; $path: string }>`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-y: auto;

  @supports (-webkit-touch-callout: none) {
    //아이폰 하단 주소창 이슈 수정 , 하단 fixed 요소
    height: 100dvh;
  }
  ${(props) =>
    props.media === 'pc' &&
    css`
      min-height: 945px;
      width: 460px;
      min-width: 460px;
      padding: 0;
      box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.08);
    `}

  ${(props) =>
    props.media !== 'pc' &&
    css`
      max-width: 640px;
      width: 100%;
      padding: 48px 20px 64px 20px;
    `}
  ${(props) =>
    (props.$path === '/' || props.$path === '/reset' || props.$path === '/camera') &&
    props.media !== 'pc' &&
    css`
      max-width: 640px;
      width: 100%;
      padding: 48px 20px 0 20px;
    `}
`

export const RightLayoutWrap = styled.div<{
  media: string
  $path: string
  $locationInfolength?: number
}>`
  display: ${(props) => (props.media !== 'pc' ? 'none' : 'flex')};
  width: ${(props) => (props.media !== 'pc' ? 'unset' : '100%')};
  height: ${(props) => (props.media !== 'pc' ? 'unset' : `calc(var(--vh, 1vh) * 100)`)};
  min-height: ${(props) => (props.media !== 'pc' ? 'unset' : '945px')};
  margin: ${(props) => (props.media !== 'pc' ? 'unset' : '0 auto')};

  ${(props) =>
    props.$path === '/' || props.$path === '/reset'
      ? css`
          background-color: rgba(210, 252, 235);
        `
      : props.media === 'pc' && props.$locationInfolength !== 0 && props.$path === '/location'
      ? css`
          display: inline-block;
        `
      : css`
          background-repeat: no-repeat;
          background-position: 50% 50%;
          background-size: 196px;
          background-color: ${COLOR.black2};
          background-image: url(${logo});
          opacity: 0.4;
        `}
`
